export const NOTIFICATION_CHANNEL = {
  PUSH: 'PUSH',
  EMAIL: 'EMAIL',
  SMS: 'SMS',
};
